import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';


export function isGroupSetsEnabledForSite() {
    return FeatureFlags.permissionsGroupLogicalAndEnabled && SessionSiteSelectors.isGroupSetsEnabledForSite(getAppStore().getState());
}